import { FC } from "react";
import { Input, Label } from "@capacit-com/lara-law-shared-ui";
import { RecentSearchesWidgetConfig } from "@/models/dashboard/WidgetConfig";
import { parseOptionalMaxItems } from "../lib/parseWidgetMaxItems";

interface RecentSearchesConfigFormProps {
  config: RecentSearchesWidgetConfig;
  onChange: (config: RecentSearchesWidgetConfig) => void;
}

const RecentSearchesConfigForm: FC<RecentSearchesConfigFormProps> = ({
  config,
  onChange,
}) => {
  const updateConfig = (updates: Partial<RecentSearchesWidgetConfig>) => {
    onChange({ ...config, ...updates });
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="recent-searches-max-items">Maks. antal (valgfrit)</Label>
      <Input
        id="recent-searches-max-items"
        type="number"
        min={1}
        placeholder="Vis alle"
        value={config.maxItems ?? ""}
        onChange={(e) => {
          updateConfig({ maxItems: parseOptionalMaxItems(e.target.value) });
        }}
      />
    </div>
  );
};

export default RecentSearchesConfigForm;
